import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { ENDPOINTS } from '../app.config';
import { CompanyService } from '../company.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-owners',
  templateUrl: './owners.component.html',
  styleUrls: ['./owners.component.css']
})
export class OwnersComponent implements OnInit {
  businessOwners: any;
  errors: any;
  currentPage = 1;
  companiesTotal: number;
  companiesPerPage: number;
  totalPages: number;
  gettingBusinessOwnersInProgress: boolean;
  router: Router;
  companyService: CompanyService;
  newBusinessOwner = {
    first_name: '',
    email: '',
    password: '',
    password_confirmation: ''
  };
  toaster: ToasterService;

  // Messages
  error_loading_companies: string;
  owner_successfully_added: string;
  password_changed_successfully: string;
  password_not_changed: string;
  owner_successfully_deleted: string;
  error_deleting_owner: string;

  constructor(
    toaster: ToasterService,
    router: Router,
    companyService: CompanyService,
    private translate: TranslateService
  ) {
    this.toaster = toaster;
    this.errors = [];
    this.router = router;
    this.companyService = companyService;
  }


  ngOnInit() {
    this.gettingBusinessOwnersInProgress = false;
    this.getCompanies();

    // Messages translations
    this.translate.stream('SHARED.Messages.error_loading_companies').subscribe((res: string) => {
      this.error_loading_companies = res;
    });
    this.translate.stream('SHARED.Messages.owner_successfully_added').subscribe((res: string) => {
      this.owner_successfully_added = res;
    });
    this.translate.stream('SHARED.Messages.password_changed_successfully').subscribe((res: string) => {
      this.password_changed_successfully = res;
    });
    this.translate.stream('SHARED.Messages.password_not_changed').subscribe((res: string) => {
      this.password_not_changed = res;
    });
    this.translate.stream('SHARED.Messages.owner_successfully_deleted').subscribe((res: string) => {
      this.owner_successfully_deleted = res;
    });
    this.translate.stream('SHARED.Messages.error_deleting_owner').subscribe((res: string) => {
      this.error_deleting_owner = res;
    });
  }


  /*
    API
  */

  getCompanies() {
    const _self = this;
    if (_self.gettingBusinessOwnersInProgress) {
      return;
    }
    _self.gettingBusinessOwnersInProgress = true;
    axios.get(ENDPOINTS.GET_BUSINESS_OWNERS).then(
      response => {
        _self.initPaging(response);
        axios
          .get(
            ENDPOINTS.GET_BUSINESS_OWNERS +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.companiesPerPage,
          )
          .then(responseWithPaging => {
            _self.gettingBusinessOwnersInProgress = false;
            _self.businessOwners = responseWithPaging.data;
            // ADD new property to existing object
            // SCOPE: Add possibility to keep the state of each businessOwner's password
            // Used in the View by the <modal>s responsible with password change at line: 100 inside ./owners.component.html
            // NOTE: On the Component: Companies, each company<Object> has by default a property: admin<Object>
            //  which has two properties: password<string> AND passwordRepeat<string>
            _self.businessOwners.forEach(businessOwner => {
              businessOwner.admin = {
                password : "",
                passwordRepeat : ""
              }
            });
          }, err => {
            _self.gettingBusinessOwnersInProgress = false;
          });
      },
      error => {
        _self.gettingBusinessOwnersInProgress = false;
        this.toaster.pop('error', this.error_loading_companies);
      },
    );
  }

  addNewBusinessOwner() {
    const _self = this;
    const isFormValid = _self.doValidation();
    if (isFormValid) {
      // autofill password_confirmation field, before HTTP POST
      _self.newBusinessOwner.password_confirmation = _self.newBusinessOwner.password;

      axios.post(ENDPOINTS.POST_BUSINESS_OWNER, _self.newBusinessOwner).then(
        response => {
          _self.toaster.pop('success', this.owner_successfully_added);
          _self.getCompanies();
          // reset
          // NOTE: This structure is used only for POST
          _self.newBusinessOwner = {
            first_name: '',
            email: '',
            password: '',
            password_confirmation: ''
          };
        },
        error => {
          _self.toaster.pop('error', error.response.data.message);
        },
      );
    }
  }

  updateBusinessOwner(businessOwner: any) {
    const _self = this;

    const patchBusinessOwner = {
      first_name: businessOwner.first_name,
      email: businessOwner.email,
    };

    axios.patch(ENDPOINTS.UPDATE_BUSINESS_OWNER.replace(':ownerId', businessOwner.id), patchBusinessOwner).then(
      response => {

      },
      error => {

      },
    );
  }

  updateBusinessOwnerPassword(businessOwner){
    let _self = this;
    let patchPassword = {
      "password": businessOwner.admin.password,
      "password_confirmation": businessOwner.admin.password_confirmation
    };

    axios.put(
      ENDPOINTS.PUT_BUSINESS_OWNER_PASSWORD.replace(':ownerId', businessOwner.id),
      patchPassword)
      .then(
      response => {
        this.resetAdminFieldPasswords(businessOwner);
        _self.toaster.pop('success', this.password_changed_successfully);
      },
      error => {
        _self.toaster.pop('error', this.password_not_changed);
      },
    );

  }

  deleteBusinessOwner(ownerId) {
    const _self = this;
    axios.delete(ENDPOINTS.DELETE_BUSINESS_OWNER.replace(':ownerId', ownerId)).then(
      response => {
        _self.getCompanies();
        _self.toaster.pop('success', this.owner_successfully_deleted);
      },
      error => {
        _self.toaster.pop('error', this.error_deleting_owner);
      },
    );
  }



  /*
    Utilities
  */

  doValidation() {
    this.errors = [];
    if (!this.newBusinessOwner.first_name) {
      this.errors.push('first_name');
    }
    if (!this.newBusinessOwner.email) {
      this.errors.push('email');
    }
    if (!this.newBusinessOwner.password) {
      this.errors.push('password');
    }
    return this.errors.length === 0;
  }

  isPasswordSubmitOff(company){
    if(typeof company.admin.password === "string" && company.admin.password.length){
      return company.admin.password !== company.admin.passwordRepeat;
    } else {
      return true;
    }
  }

  resetAdminFieldPasswords(businessOwner){
    businessOwner.admin.password='';
    businessOwner.admin.passwordRepeat='';
  }

  onEnter(event) {
    this.addNewBusinessOwner();
  }

  goToOwnerCompanies(businessOwnerId) {
    // Allow ADMINISTRATOR to access the businesOwnerId
    //   is used in breadcrumbs navigation
    localStorage.setItem("businessOwnerId", businessOwnerId);
    this.router.navigate(['companies/' + businessOwnerId]);
  }

  initPaging(response) {
    const _self = this;
    _self.companiesTotal = parseInt(response.headers['total'], 10);
    _self.companiesPerPage = parseInt(response.headers['per-page'], 10);
    _self.totalPages = Math.floor(
      _self.companiesTotal % _self.companiesPerPage,
    ) === 0
      ? _self.companiesTotal / _self.companiesPerPage
      : Math.floor(_self.companiesTotal / _self.companiesPerPage) + 1;
    // Pagination case
    //   Example: companiesTotal = 11, companiesPerPage = 10, currentPage = 2, only 1 company on the page
    //   After 11 company is deleted, page 2 doesn't exist anymore
    //   Therefore _currentPage needs to be reduced with -1
    if( _self.currentPage > _self.totalPages){
      _self.currentPage--;
    }
  }

  loadBusinessOwner(page, isDisabled) {
    if (!isDisabled && !this.gettingBusinessOwnersInProgress) {
      this.currentPage = page;
      this.getCompanies();
    }
  }

  generatePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/owners/owners.component.ts